import logEvent from 'analytics/logEvent';
import cn from 'classnames';
import Cookies from 'js-cookie';
import { useRouter } from 'next/router';
import React, { useEffect, useRef, useState } from 'react';

import AcceptCookie from 'components/complex/CookieBanner/AcceptCookie';
import CookieSettings from 'components/complex/CookieBanner/CookieSettings';

import s from './CookieBanner.module.scss';

export default function CookieBanner({
  className,
  onShowCookieBanner,
}: {
  className?: string;
  onShowCookieBanner?: () => void;
}): JSX.Element | null {
  const [isSettingsShowed, setSettingsShowed] = useState(false);
  const [isCookieBannerShowing, setCookieBannerShowing] = useState(false);
  const containerRef = useRef<HTMLDivElement>();
  const router = useRouter();

  useEffect(() => {
    const cookieAccept = Cookies.get('WELLTORY_COOKIE_ACCEPT');

    if (!cookieAccept) {
      setCookieBannerShowing(true);
    }
  }, [containerRef]);

  useEffect(() => {
    if (!isCookieBannerShowing || !containerRef.current) {
      return;
    }

    onShowCookieBanner?.();
  }, [onShowCookieBanner, isCookieBannerShowing]);

  function onClose(): void {
    logEvent('Web_Cookie_Accept_Button_Clicked');
    setCookieBannerShowing(false);
    Cookies.set('WELLTORY_COOKIE_ACCEPT', '1');
  }

  function showSettings(): void {
    logEvent('Web_Cookie_Settings_Button_Clicked');
    setSettingsShowed(true);
  }

  if (
    !isCookieBannerShowing ||
    router.pathname.startsWith('/payments/plans') ||
    router.pathname.startsWith('/profile') ||
    router.query.compact
  ) {
    // do not show cookies block on /payments/plans/* routes
    return null;
  }

  return (
    // @ts-ignore
    <div className={cn(s.wrapper, 'CookieBanner', className)} ref={containerRef}>
      {isSettingsShowed ? (
        <CookieSettings onClose={onClose} />
      ) : (
        <AcceptCookie showSettings={showSettings} onClose={onClose} />
      )}
    </div>
  );
}
